var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polygon',{attrs:{"points":"7,0 13,7 8,7 8,17 6,17 6,7 1,7 "}}),_c('polygon',{attrs:{"points":"18,7 18,17 23,17 17,24 11,17 16,17 16,7 "}})])
}
var staticRenderFns = []

export { render, staticRenderFns }